import DeprecatedUsersAndTeamsSelect from './DeprecatedUsersAndTeamsSelect';
import { NewUsersAndTeamsSelect } from './NewUsersAndTeamsSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const checkHasObjectTypeId = props => !!props.objectTypeId && typeof props.objectTypeId === 'string';
const checkIsNewProps = props => props.shouldFetchTeams === true || checkHasObjectTypeId(props);

// This is an odd way to support good typing for both the old and new components
// This is the actual component but we wrap it below to allow for function overloads
// which allow for more specific typings to be understood by the consumers
// Because of the overloads, this ESLint rule breaks even though we've set the
// display name
// eslint-disable-next-line react/display-name
export function UsersAndTeamsSelect(props) {
  if (checkIsNewProps(props)) {
    return /*#__PURE__*/_jsx(NewUsersAndTeamsSelect, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(DeprecatedUsersAndTeamsSelect, Object.assign({}, props));
}
UsersAndTeamsSelect.displayName = 'UsersAndTeamsSelect';
export default UsersAndTeamsSelect;